import { useSite } from "@/lib/useSite";
import { PublicLayout, FinalCta } from "@/components/site";
import { HomeHero, LeadSection } from "@/components/home/HomeHero";
import { SelectedWork } from "@/components/home/HomeWork";
import { HomeServices } from "@/components/home/HomeServices";
import { HomeTestimonials } from "@/components/home/HomeTestimonials";
import { IndustryConnections } from "@/components/home/IndustryConnections";
import { FeaturedFilm, BrandStatement, Process, PortalPreview, Markets } from "@/components/home/HomeSections";
import { MoreServices } from "@/components/MoreServices";

export default function Landing() {
  const { settings, projects, markets, industry_logos } = useSite();
  return (
    <PublicLayout overlay stickyBook>
      <HomeHero settings={settings} projects={projects} />
      <LeadSection />
      <HomeServices projects={projects} settings={settings} />
      <SelectedWork projects={projects} />
      <IndustryConnections logos={industry_logos} backgroundImage={settings.cta_image_url} />
      <HomeTestimonials />
      <MoreServices />
      <FeaturedFilm settings={settings} />
      <BrandStatement />
      <Process />
      <PortalPreview settings={settings} />
      <Markets markets={markets} />
      <FinalCta image={settings.cta_image_url} />
    </PublicLayout>
  );
}
